export const searchQueryKeyMap = {
  projects: (params?: object) =>
    ['projects', params].filter((item) => item !== undefined),
  ProjectFiscalYear: () => ['ProjectFiscalYear'],
  projectAnalysis: (params?: object) =>
    ['projectAnalysis', params].filter((item) => item !== undefined),
  ksAnalysis: (params?: object) =>
    ['ksAnalysis', params].filter((item) => item !== undefined),
};
